// @flow

import React from "react";
import {Popconfirm, message} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../hooks/useStore";

export const SlotCreatePopConfirm = ({
    poolId,
    forecastDate,
    slotDate,
    hourId,
    recall = () => {},
    disabled = false,
    children
}) => {
    const stores = useStore();
    const {t} = useTranslation();
    const submitForm = async () => {
        try {
            if (!poolId) {
                message.error("Havuz seçiniz");
                return;
            }

            if (!slotDate || !forecastDate) {
                message.error("Tarih seçiniz");
                return;
            }

            if (!hourId) {
                message.error("Saat seçiniz");
                return;
            }

            const createSlotResult = await stores.poolShiftStore.createPoolShiftDailySlot({
                poolId,
                shiftHourId: hourId,
                forecastDate,
                slotDate
            });

            if (!createSlotResult) {
                return;
            }
            message.success("Slot oluşturuldu");
            recall();
        } catch (error) {
            let errorMessage =
                error?.message ||
                t("errorMessages.AnUnknownErrorWasOccurred", {
                    ns: "common"
                });
            if (error?.errors?.length > 0) {
                errorMessage = error.errors.join("\n");
            }
            stores.appStore.openErrorModal({content: errorMessage});
        }
    };

    return disabled ? (
        <>{children}</>
    ) : (
        <Popconfirm
            title={"Slot Oluştur"}
            onConfirm={submitForm}
            okText={t("modal.sendButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {
                ns: "common"
            })}
        >
            {children}
        </Popconfirm>
    );
};
